import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generateKOTPDF = async (labelData) => {
    if (!labelData || !labelData.KOTPrint) return;

    const itemCount = labelData.KOTPrintItems?.length || 0;
    const dynamicHeight = Math.max(150, 80 + itemCount * 10 + 40);

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [71, dynamicHeight],
    });

    let y = 10;

    // ------------------ Company Header ------------------
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(labelData.KOTPrint.CompanyName || "", 36, y, { align: "center" });
    y += 8;

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(labelData.KOTPrint.IsReprint ? "KOT BILL (Reprinted)" : "KOT BILL", 36, y, { align: "center" });
    y += 7;

    // ------------------ KOT Info ------------------
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");

    const kotDate = new Date(labelData.KOTPrint.KOTDate).toLocaleDateString("en-GB");
    const kotTime = new Date(`2000-01-01T${labelData.KOTPrint.KOTTime}`).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    doc.text(`Date: ${kotDate}`, 5, y, { align: "left" });
    doc.text(`Time: ${kotTime}`, 67, y, { align: "right" });
    y += 4;

    doc.text(`KOT No: ${labelData.KOTPrint.KOTNumber}`, 5, y, { align: "left" });
    doc.text(`Table: ${labelData.KOTPrint.TableName || ""}`, 67, y, { align: "right" });
    y += 5;

    // ------------------ Item Table ------------------
    const marginX = 1.5;
    const pageWidth = doc.internal.pageSize.getWidth();
    const usableWidth = pageWidth - marginX * 2;

    const tableColumns = ["No", "Particular", "Qty"];
    const tableRows = labelData.KOTPrintItems.map((item) => [
        item.SerialNo,
        item.ItemName || "",
        item.Quantity,
    ]);

    const totalQty = labelData.KOTPrintItems.reduce((sum, i) => sum + (parseFloat(i.Quantity) || 0), 0);

    tableRows.push([
        { content: "Total", colSpan: 2, styles: { halign: "right", fontStyle: "bold" } },
        { content: totalQty.toFixed(2), styles: { halign: "center", fontStyle: "bold" } },
    ]);

    autoTable(doc, {
        startY: y,
        head: [tableColumns],
        body: tableRows,
        theme: "grid",
        styles: { fontSize: 9, lineColor: [0, 0, 0], lineWidth: 0.2 },
        headStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold", fontSize: 8, halign: "center" },
        bodyStyles: { textColor: [0, 0, 0] },
        columnStyles: {
            0: { halign: "center", cellWidth: usableWidth * 0.12 },
            1: { halign: "left",   cellWidth: usableWidth * 0.68 },
            2: { halign: "center", cellWidth: usableWidth * 0.2 },
        },
        margin: { left: marginX, right: marginX },
        didDrawPage: (data) => (y = data.cursor.y),
    });   

    // ------------------ Print ------------------
    const blob = doc.output("blob");
    const blobUrl = URL.createObjectURL(blob);
    const win = window.open(blobUrl, "_blank");
    if (win) {
        win.onload = () => setTimeout(() => win.print(), 500);
    }
};
